export enum RegainChannel {
  Email = "email",
  Popup = "popup",
  Whatsapp = "whatsapp"
}
